import { Button } from "./ui/button";
import { FileText, Star } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    const el = document.getElementById("how-it-works");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = "/#how-it-works";
    }
  };

  return (
    <div className="relative min-h-[60vh] flex items-center justify-center overflow-hidden pt-16 px-4 sm:px-6 md:px-8 py-8 sm:py-12 md:py-16">
      <div className="absolute inset-0 -z-10">
        <div className="gradient-bg absolute top-0 right-0 w-[300px] h-[300px] sm:w-[400px] sm:h-[400px] md:w-[500px] md:h-[500px] animate-float" />
        <div className="gradient-bg absolute bottom-0 left-0 w-[300px] h-[300px] sm:w-[400px] sm:h-[400px] md:w-[500px] md:h-[500px] animate-float delay-500" />
        <div className="absolute top-1/4 left-1/3 w-40 h-40 sm:w-56 sm:h-56 md:w-72 md:h-72 bg-pink-400 opacity-30 rounded-full blur-3xl animate-float-slow" />
        <div className="absolute bottom-10 right-1/4 w-48 h-48 sm:w-64 sm:h-64 md:w-80 md:h-80 bg-blue-400 opacity-20 rounded-full blur-2xl animate-float" style={{ animationDelay: '1.2s' }} />
        <div className="absolute top-10 right-1/2 w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 bg-purple-400 opacity-20 rounded-full blur-2xl animate-float" style={{ animationDelay: '2s' }} />
        <style>{`
          @keyframes float-slow {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-30px); }
            100% { transform: translateY(0px); }
          }
          .animate-float-slow {
            animation: float-slow 10s ease-in-out infinite;
          }
        `}</style>
      </div>
      <div className="container px-0 sm:px-4 mx-auto">
        <div className="text-center max-w-4xl mx-auto">
          <div className="flex items-center justify-center gap-2 mb-6">
            <Star className="text-primary w-5 h-5" />
            <span className="text-xs sm:text-sm font-medium">All-in-One AI Study Platform</span>
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-6xl font-extrabold mb-8 sm:mb-10 pt-6 sm:pt-8 pb-4 sm:pb-6 bg-gradient-to-r from-primary via-pink-400 to-purple-400 bg-clip-text text-transparent animate-gradient-shimmer relative overflow-hidden" style={{ textShadow: '0 2px 24px rgba(58,134,255,0.25), 0 1px 2px rgba(0,0,0,0.08)' }}>
            Your Complete AI-Powered Study Suite
            <style>{`
              @keyframes gradient-shimmer {
                0% { background-position: 0% 50%; }
                100% { background-position: 200% 50%; }
              }
              .animate-gradient-shimmer {
                background-image: linear-gradient(90deg, #3A86FF, #FF61A6, #A259FF, #00B4D8, #3A86FF);
                background-size: 400% 400%;
                animation: gradient-shimmer 1.5s linear infinite alternate;
              }
            `}</style>
          </h1>
          <p className="text-sm sm:text-base md:text-lg font-medium mb-6 mt-2 max-w-2xl mx-auto text-gray-700">
            The only platform where you can <span className="font-extrabold">upload, chat, quiz, and master</span>—all powered by next-gen AI. Effortlessly turn your books and notes into interactive mock exams, study guides, and instant answers. <span className="font-bold">Study smarter, not harder.</span>
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button size="lg" className="bg-primary hover:bg-primary/90 w-full sm:w-auto" onClick={() => navigate("/signup") }>
              <FileText className="mr-2 h-5 w-5" />
              Get Started
            </Button>
            <Button size="lg" variant="outline" className="w-full sm:w-auto" onClick={handleLearnMore}>
              Learn More
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero; 